import axios from "axios";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import ModalWinners from "./modalWinners";
import ModalAvaliar from "./modalAvaliar";

import NoImageChamada from "../../assets/images/v2/jogos/img-thumb-jogo-boom.jpg";

function CallsInscriptionsEvent() {
  const [eventos, setEventos] = useState([]);
  const [eventosVisible, setEventosVisible] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  const [categoria, setCategoria] = useState(-1);
  const [remove, setRemove] = useState(false);
  const [inscription, setInscription] = useState(null);
  const [catVencedores, setCatVencedores] = useState([]);
  const [users, setUsers] = useState([]);
  const intl = useIntl();
  let { id } = useParams();

  useEffect(() => {
    loadChamadas();
  }, []);

  useEffect(() => {
    var filtered = eventos;
    if (searchUserName != "") {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(searchUserName.toLowerCase())
      );
    }

    if (categoria != -1) {
      filtered = filtered.filter((item) => {
        if (item.award != null) {
          if (item.award.includes(categoria)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    }

    setEventosVisible(filtered);
  }, [searchUserName, categoria]);

  function loadChamadas() {
    axios
      .get(`/api/v1/rating/rated/games/winners/${id}`, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      })
      .then((res) => {
        console.log("eventos", res.data);
        let vencedores = [];
        setEventos(res.data);
        setEventosVisible(res.data);
        if (res.data.length != 0) {
          res.data.forEach((element) => {
            if (element.award != null) {
              if (element.award.length != 0) {
                vencedores = vencedores.concat(element.award);
              }
            }
          });

          if (vencedores.length != 0) {
            vencedores = vencedores.filter((v, i, a) => a.indexOf(v) === i);
          }
          setCatVencedores(vencedores);
        }
      })
      .catch((error) => {
        console.log("error", error);
        // if (error.response.status === 401) {
        //   localStorage.removeItem("token");
        //   window.open("/", "_self");
        // }
      });
  }

  function renderBreadcrumb() {
    return (
      <div className="row page-titles">
        <div className="col p-0">
          <h4>
            <FormattedMessage id="app.welcome-1" />,{" "}
            <span>
              <FormattedMessage id="app.welcome-2" />
            </span>
          </h4>
        </div>
        <div className="col p-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/"} title="Dashboard">
                <FormattedMessage id="app.menu.dashboard" />
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={"/call/mark-winners/"} title="Marcar Vencedores">
                <FormattedMessage id="app.menu.mark-winners" />
              </Link>
            </li>
            <li className="breadcrumb-item active">
              {eventos.length ? (
                eventos[0].event.name
              ) : (
                <FormattedMessage id="loading" />
              )}
            </li>
          </ol>
        </div>
      </div>
    );
  }

  function renderFilter() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <form className="form-custom content-filter">
                <div className="filter">
                  <div className="form-row">
                    <div className="col-12">
                      <h2 className="card-title">
                        <FormattedMessage id="calls.registered.filter.title" />
                      </h2>
                    </div>
                    <div className="form-group col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <label>
                        <FormattedMessage id="calls.inscriptions.event.finalist.filter-name" />
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={searchUserName}
                        onChange={({ target }) =>
                          setSearchUserName(target.value)
                        }
                        placeholder="Nome do jogo"
                      />
                    </div>
                    <div className="form-group col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <label>
                        <FormattedMessage id="categoria-vencedores" />
                      </label>
                      <select
                        className="form-control form-control-sm"
                        value={categoria}
                        onChange={({ target }) => setCategoria(target.value)}
                      >
                        <option value={-1}>Todas</option>
                        {eventos.length &&
                          eventos[0].event.categoria_avaliacao.length &&
                          eventos[0].event.categoria_avaliacao.map((c, i) => {
                            return (
                              <option key={i} value={c}>
                                {c}
                              </option>
                            );
                          })}
                        {eventos.length &&
                          eventos[0].event.categoria_extras.length &&
                          eventos[0].event.categoria_extras.map((c, i) => {
                            return (
                              <option key={i} value={c}>
                                {c}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function isShowAward(game) {
    console.log("game --->", game);
    let retorno = false;

    console.log("catVencedores", catVencedores);
    game.catHabilitadas.forEach((v) => {
      if (!catVencedores.includes(v)) {
        console.log("entrei");
        if (retorno === false) retorno = true;
      }
    });

    return retorno;
  }

  function isShowUsersWhoHaveYetToRate(teams) {
    let retorno = false;

    teams.forEach((team) => {
      if (team.assessmentsNeeded > team.numberOfAssessmentsMade) retorno = true;
    });

    return retorno;
  }

  function renderList() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <FormattedMessage id="app.menu.mark-winners" />
              </h4>

              <div className="event-list games">
                {eventosVisible.length ? (
                  eventosVisible.map((game, index) => {
                    return (
                      <div className="row" key={index}>
                        <div className="col-12">
                          <div className="row">
                            <div className="col-xx-1 col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
                              <div className="image-event">
                                <img
                                  src={game.image ? game.image : NoImageChamada}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="col-xx-11 col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
                              <div className="info">
                                <div className="row w-100">
                                  {game.award !== null &&
                                    game.award.length != 0 && (
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                        <h3>
                                          <FormattedMessage id="dashboard.game.award" />
                                        </h3>
                                        <p>{game.award.toString()}</p>
                                      </div>
                                    )}

                                  {game.finalist !== null &&
                                    game.finalist.length != 0 && (
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                        <FormattedMessage id="calls.inscriptions.event.finalist.label" />
                                        <p>{game.finalist.toString()}</p>
                                      </div>
                                    )}

                                  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                    <h3>
                                      <FormattedMessage id="calls.inscriptions.event.finalist.category.label" />
                                    </h3>
                                    <p>
                                      {game.event.categoria_avaliacao
                                        .concat(game.event.categoria_extras)
                                        .toString()}
                                    </p>
                                  </div>
                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <h3>{game.name}</h3>
                                    <p>{game.description}</p>
                                  </div>
                                  {game.teams.length != 0 &&
                                    game.teams.map((team) => {
                                      return team.avaliacoes.map(
                                        (avaliacao, indexAva) => {
                                          console.log("avaliacao", avaliacao);
                                          return (
                                            <>
                                              <div
                                                key={indexAva}
                                                className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                              >
                                                <h3>
                                                  <FormattedMessage id="avaliacoes-da-equipe" />{" "}
                                                  {team.name}
                                                </h3>
                                                <h3>
                                                  {avaliacao.user.profile.name}(
                                                  {avaliacao.user.login})
                                                </h3>
                                                {Object.keys(
                                                  avaliacao.rating_juri
                                                ).map((key, i) => {
                                                  return (
                                                    <div key={i} className="">
                                                      <p className="d-inline">
                                                        Categoria {key}:{" "}
                                                      </p>

                                                      {Object.keys(
                                                        avaliacao.rating_juri[
                                                          key
                                                        ]
                                                      ).map((keyGame) => {
                                                        return (
                                                          <p className="d-inline">
                                                            Nota:{" "}
                                                            {
                                                              avaliacao
                                                                .rating_juri[
                                                                key
                                                              ][keyGame].nota
                                                            }{" "}
                                                            - Comentário:{" "}
                                                            {
                                                              avaliacao
                                                                .rating_juri[
                                                                key
                                                              ][keyGame].comment
                                                            }
                                                          </p>
                                                        );
                                                      })}
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                              <hr style={{ width: "100%" }} />
                                            </>
                                          );
                                        }
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="content-btn col-12 d-flex justify-content-end">
                                {game.award !== null &&
                                  game.award.length != 0 && (
                                    <button
                                      className="btn btn-outline-primary"
                                      onClick={(e) => {
                                        setRemove(true);
                                        setInscription(game);
                                        // eslint-disable-next-line no-undef
                                        $("#modalFinalist").modal("show");
                                      }}
                                    >
                                      <FormattedMessage id="remover-titulo-de-vencedor" />
                                    </button>
                                  )}
                                {isShowAward(game) && (
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => {
                                      setRemove(false);
                                      setInscription(game);
                                      // eslint-disable-next-line no-undef
                                      $("#modalFinalist").modal("show");
                                    }}
                                  >
                                    <FormattedMessage id="marcar-vencedor" />
                                  </button>
                                )}
                                {isShowUsersWhoHaveYetToRate(game.teams) && (
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => {
                                      setUsers(game.teams);
                                      // eslint-disable-next-line no-undef
                                      $("#modalAvaliar").modal("show");
                                    }}
                                  >
                                    <FormattedMessage id="marcar-vencedor" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <FormattedMessage id="calls.inscriptions.event.finalist.empty" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-body">
      <div className="container-fluid">
        {renderBreadcrumb()}
        {renderFilter()}
        {renderList()}
        <ModalWinners
          catVencedores={catVencedores}
          inscription={inscription}
          remove={remove}
          reload={loadChamadas}
        />
        <ModalAvaliar users={users} />
      </div>
    </div>
  );
}

export default injectIntl(withAuth(CallsInscriptionsEvent));
